import React, {Fragment} from 'react';

import {Skeleton, Stack} from '@mui/material';
import {useMediaQueries} from 'presentation/pages/private/hooks';

export function Loading() {
	const {isMobile} = useMediaQueries();

	return (
		<Stack gap={isMobile ? 2 : 1}>
			<Skeleton variant="rectangular" height={26} />
			<Skeleton variant="rectangular" height={18} width={'43%'} />
			<Skeleton variant="rectangular" height={18} width={'28%'} />
			{isMobile ? (
				<Fragment>
					<Skeleton variant="rectangular" height={18} width={'65%'} />
					<Skeleton variant="rectangular" height={18} width={'43%'} />
					<Skeleton variant="rectangular" height={18} width={'65%'} />
					<Skeleton variant="rectangular" height={18} width={'43%'} />
				</Fragment>
			) : (
				<Fragment>
					<Skeleton variant="rectangular" height={18} width={'43%'} />
					<Skeleton variant="rectangular" height={18} width={'28%'} />
				</Fragment>
			)}
		</Stack>
	);
}
